import "./App.css";
import {
  Label,
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
  Input,
} from "@headlessui/react";
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/react/20/solid";
import { useContext, useEffect, useState } from "react";

import moment from "moment";
import _ from "lodash";
import useLocalStorage from "./Hooks/useLocalStorage";
import { UserContext } from "./contexts/UserContext";
import CalendarUI from "./UI/Calendar/CalendarUI";
import {
  ApolloClient,
  createHttpLink,
  getApolloContext,
  gql,
  InMemoryCache,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = localStorage.getItem("token");
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `${token}` : "",
    },
  };
});

const httpLink = createHttpLink({
  uri:
    (window.ENV?.REACT_APP_PROJECT_SERVER ||
      process.env.REACT_APP_PROJECT_SERVER) + "/graphql",
});

const project_client = new ApolloClient({
  cache: new InMemoryCache(),
  link: authLink.concat(httpLink),
});

const GET_ENGINES = gql`
  query GetEngines {
    enginesForUser {
      name
      _id
      key
    }
  }
`;

const channels = [
  {
    _id: 1,
    name: "Sky Sports PL",
    image: "Football_Plus/Channel_logos/SS_PL.png",
  },
  {
    _id: 2,
    name: "Sky Sports Football",
    image: "Football_Plus/Channel_logos/SS_Football.png",
  },
  {
    _id: 3,
    name: "Sky Sports Mix",
    image: "Football_Plus/Channel_logos/SS_Mix.png",
  },
  {
    _id: 4,
    name: "Sky Sports Main Event",
    image: "Football_Plus/Channel_logos/SS_MainEvent.png",
  },
  {
    _id: 5,
    name: "Sky Sports Arena",
    image: "Football_Plus/Channel_logos/SS_Arena.png",
  },
  {
    _id: 6,
    name: "Sky Sports Action",
    image: "Football_Plus/Channel_logos/SS_Action.png",
  },
  {
    _id: 7,
    name: "Sky Sports",
    image: "Football_Plus/Channel_logos/SS.png",
  },
  {
    _id: 8,
    name: "Sky Sports+",
    image: "Football_Plus/Channel_logos/SS+.png",
  },

  {
    _id: 9,
    name: "Sky Sports Cricket",
    image: "Football_Plus/Channel_logos/SS_Cricket.png",
  },
  {
    _id: 10,
    name: "Sky Sports F1",
    image: "Football_Plus/Channel_logos/SS_F1.png",
  },
  {
    _id: 11,
    name: "Sky Sports Golf",
    image: "Football_Plus/Channel_logos/SS_Golf.png",
  },
  {
    _id: 12,
    name: "Sky Sports News",
    image: "Football_Plus/Channel_logos/SS_News.png",
  },
  {
    _id: 13,
    name: "Sky Sports NFL",
    image: "Football_Plus/Channel_logos/SS_NFL.png",
  },
  {
    _id: 14,
    name: "Sky Sports Racing",
    image: "Football_Plus/Channel_logos/SS_Racing.png",
  },
  {
    _id: 15,
    name: "Sky Sports Tennis",
    image: "Football_Plus/Channel_logos/SS_Tennis.png",
  },
  // {
  //   _id: 16,
  //   name: "Sky Max",
  //   image: "Football_Plus/Channel_logos/Sky_Max.png",
  // },
  {
    _id: 17,
    name: "Sky Showcase",
    image: "Football_Plus/Channel_logos/Sky_Showcase.png",
  },
  {
    _id: 18,
    name: "Sky Comedy",
    image: "Football_Plus/Channel_logos/Sky_Comedy.png",
  },
  {
    _id: 19,
    name: "Sky One",
    image: "Football_Plus/Channel_logos/Sky_One.png",
  },
  {
    _id: 20,
    name: "Sky Nature",
    image: "Football_Plus/Channel_logos/Sky_Nature.png",
  },
  {
    _id: 21,
    name: "Sky Crime",
    image: "Football_Plus/Channel_logos/Sky_Crime.png",
  },
  {
    _id: 22,
    name: "Sky Arts",
    image: "Football_Plus/Channel_logos/Sky_Arts.png",
  },
  {
    _id: 23,
    name: "Sky Witness",
    image: "Football_Plus/Channel_logos/Sky_Witness.png",
  },
  {
    _id: 24,
    name: "Sky Atlantic",
    image: "Football_Plus/Channel_logos/Sky_Atlantic.png",
  },
  {
    _id: 25,
    name: "Sky History",
    image: "Football_Plus/Channel_logos/Sky_History.png",
  },
];

function App() {
  const [games, setGames] = useState([]);
  const [fixtures, setFixtures] = useState([]);
  const [changesPending, setChangesPending] = useState(false);
  const [rossID, setRossID] = useState();
  const [template, setTemplate] = useState({
    id: 1,
    name: "4 GAMES",
  });
  const [engine, setEngine] = useState();
  const [engines, setEngines] = useState();
  const { user, signOut, loggedIn } = useContext(UserContext);
  const [commentators, setCommentators] = useState("");
  const [view, setView] = useLocalStorage("hyper-football-plus-view", "");
  const [date, setDate] = useState(moment().format("YYYY-MM-DD"));
  const [momentDate, setMomentDate] = useState(moment());
  const [selectedMonth, setSelectedMonth] = useState(moment());
  const [showCalendar, setShowCalendar] = useState(false);

  useEffect(() => {
    project_client
      .query({
        query: GET_ENGINES,
      })
      .then((response) => {
        setEngines(
          response.data.enginesForUser.map((e) => ({
            ...e,
          })),
        );
      })
      .catch((err) => console.error(err));
  }, [loggedIn]);

  useEffect(() => {
    fetch("/fixtures?date=" + date, {
      headers: { Authorization: "Bearer " + window?.ENV?.API_TOKEN },
    })
      ?.then((res) => res?.json())
      ?.then((data) => {
        setFixtures(data?.games);
      })
      ?.catch((err) => {
        console.log(err);
      });
    getStatus();
  }, [date]);

  useEffect(() => {
    let interval;
    if (changesPending === false) {
      interval = setInterval(() => {
        getStatus();
      }, [1000]);
    }
    return () => {
      clearInterval(interval);
    };
  }, [changesPending]);

  function getStatus() {
    fetch("/status", {
      headers: { Authorization: "Bearer " + window?.ENV?.API_TOKEN },
    })
      ?.then((res) => res?.json())
      ?.then((data) => {
        setGames(data?.games ?? []);
        setCommentators(data?.commentators);
        setRossID(data?.ross_id);
        setEngine(data?.engine);
        setTemplate(data?.template);
      })
      ?.catch((err) => {
        console.log(err);
      });
  }

  function save() {
    setChangesPending(false);
    let new_games = JSON.parse(JSON.stringify(games));
    if (template?.id === 2) {
      new_games = new_games?.filter((g) => g?.slot !== 4);
    }
    fetch("/games", {
      method: "POST",
      body: JSON.stringify({
        games: new_games,
        commentators,
        template,
        rossID: rossID?.name,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window?.ENV?.API_TOKEN,
      },
    });
  }

  function updateGame({ index, game }) {
    setChangesPending(true);
    if (index > -1) {
      let new_games = JSON.parse(JSON.stringify(games));
      new_games = new_games?.filter((g) => g?.slot !== index);
      new_games.push({ ...game, slot: index });
      new_games = new_games.sort((a, b) => {
        return a?.slot - b?.slot;
      });
      setGames(new_games);
    }
  }

  function updateGameAndSave({ index, game }) {
    if (index > -1) {
      let new_games = JSON.parse(JSON.stringify(games));
      new_games = new_games?.filter((g) => g?.slot !== index);
      new_games.push({ ...game, slot: index });
      new_games = new_games.sort((a, b) => {
        return a?.slot - b?.slot;
      });
      fetch("/games", {
        method: "POST",
        body: JSON.stringify({
          games: new_games,
          commentators,
          template,
          rossID: rossID?.name,
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + window?.ENV?.API_TOKEN,
        },
      });
    }
  }

  function updateChannel({ index, channel }) {
    setChangesPending(true);
    if (index > -1) {
      let new_games = JSON.parse(JSON.stringify(games));
      new_games.find((g) => g?.slot === index).channel = channel;
      setGames(new_games);
    }
  }

  function updateScore({ index, game }) {
    if (index > -1) {
      let new_games = JSON.parse(JSON.stringify(games));
      new_games = new_games?.filter((g) => g?.slot !== index);
      new_games.push({ ...game, slot: index });
      new_games = new_games.sort((a, b) => {
        return a?.slot - b?.slot;
      });

      fetch("/games", {
        method: "POST",
        body: JSON.stringify({
          games: new_games,
          commentators,
          template,
          rossID: rossID?.name,
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + window?.ENV?.API_TOKEN,
        },
      });
    }
  }

  return (
    <div className="h-full text-[#dfe9e8] flex">
      <div className="col-span-1 w-5/6 h-full">
        <div className="grid grid-cols-2 w-full h-full">
          {new Array(template?.id === 1 ? 4 : 3)
            ?.fill(1)
            ?.map((game, index) => {
              return (
                <BasicGame
                  view={view}
                  index={index + 1}
                  games={games}
                  fixtures={fixtures}
                  updateGame={updateGame}
                  updateChannel={updateChannel}
                  channels={channels}
                  updateScore={updateScore}
                  changesPending={changesPending}
                  updateGameAndSave={updateGameAndSave}
                />
              );
            })}
        </div>
      </div>
      <div className="col-span-1 w-1/6 h-full  m-1 p-1 shadow-sm bg-[#181d25] flex flex-col">
        <div className="flex w-full p-1 bg-[#202731] items-center">
          {user?.username}
          <div
            className="ml-auto rounded-md bg-indigo-600 hover:bg-indigo-400 px-3.5 py-2.5 text-sm text-white shadow-sm"
            onClick={() => {
              signOut();
            }}
          >
            Sign Out
          </div>
        </div>

        <div className="flex m-4">
          {engines?.find((e) => e?.key === engine)?.name}
        </div>
        <div className="flex m-4">{rossID}</div>
        {/* <Listbox value={rossID} onChange={setRossID}>
          <div className="relative m-4">
            <ListboxButton className="grid w-full cursor-default grid-cols-1 rounded-md bg-[#0e1219] py-1.5 pl-3 pr-2 text-left outline outline-1 -outline-offset-1 outline-[#363c48] focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6">
              <span className="col-start-1 row-start-1 truncate pr-6">
                {rossID?.name}
              </span>
              <ChevronUpDownIcon
                aria-hidden="true"
                className="col-start-1 row-start-1 size-5 self-center justify-self-end text-gray-500 sm:size-4"
              />
            </ListboxButton>

            <ListboxOptions
              transition
              className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-[#0e1219] py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in sm:text-sm"
            >
              {[
                { id: 1, name: "ROSS_1" },
                { id: 2, name: "ROSS_2" },
                { id: 3, name: "ROSS_3" },
                { id: 4, name: "ROSS_4" },
              ]?.map((ross) => (
                <ListboxOption
                  key={ross.id}
                  value={ross}
                  className="group relative cursor-default select-none py-2 pl-3 pr-9 data-[focus]:bg-indigo-600 data-[focus]:text-white data-[focus]:outline-none"
                >
                  <span className="block truncate font-normal group-data-[selected]:font-semibold">
                    {ross.name}
                  </span>

                  <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600 group-[&:not([data-selected])]:hidden group-data-[focus]:text-white">
                    <CheckIcon aria-hidden="true" className="size-5" />
                  </span>
                </ListboxOption>
              ))}
            </ListboxOptions>
          </div>
        </Listbox> */}
        <Listbox
          value={template}
          onChange={(value) => {
            setChangesPending(true);
            setTemplate(value);
          }}
        >
          <div className="relative m-4">
            <ListboxButton className="grid w-full cursor-default grid-cols-1 rounded-md bg-[#0e1219] py-1.5 pl-3 pr-2 text-left outline outline-1 -outline-offset-1 outline-[#363c48] focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6">
              <span className="col-start-1 row-start-1 truncate pr-6">
                {template?.name}
              </span>
              <ChevronUpDownIcon
                aria-hidden="true"
                className="col-start-1 row-start-1 size-5 self-center justify-self-end text-gray-500 sm:size-4"
              />
            </ListboxButton>

            <ListboxOptions
              transition
              className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-[#0e1219] py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in sm:text-sm"
            >
              {[
                { id: 1, name: "4 GAMES" },
                { id: 2, name: "3 GAMES" },
              ]?.map((t) => (
                <ListboxOption
                  key={t?.id}
                  value={t}
                  className="group relative cursor-default select-none py-2 pl-3 pr-9 data-[focus]:bg-indigo-600 data-[focus]:text-white data-[focus]:outline-none"
                >
                  <span className="block truncate font-normal group-data-[selected]:font-semibold">
                    {t?.name}
                  </span>

                  <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600 group-[&:not([data-selected])]:hidden group-data-[focus]:text-white">
                    <CheckIcon aria-hidden="true" className="size-5" />
                  </span>
                </ListboxOption>
              ))}
            </ListboxOptions>
          </div>
        </Listbox>
        <div className="flex m-4 gap-x-4">
          <div
            className="cursor-pointer"
            onClick={() => {
              setShowCalendar(!showCalendar);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="size-6 "
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"
              />
            </svg>
          </div>
          {moment(date).format("YYYY-MM-DD")}
        </div>
        {showCalendar && (
          <CalendarUI
            onChangeDate={(date) => {
              setDate(moment(date).format("YYYY-MM-DD"));
              setMomentDate(moment(date));
              setSelectedMonth(moment(date));
            }}
            date={momentDate}
            highlights={[]}
          />
        )}
        <div className="flex m-4">Commentators</div>
        <Input
          value={commentators}
          className="grid w-full cursor-default grid-cols-1 rounded-md bg-[#0e1219] py-1.5 pl-3 pr-2 text-left outline outline-1 -outline-offset-1 outline-[#363c48] focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
          onChange={(e) => {
            setChangesPending(true);
            setCommentators(e.currentTarget.value);
          }}
        />
        {changesPending && (
          <>
            <button
              type="button"
              className="m-3 rounded-md bg-indigo-600 hover:bg-indigo-400 px-3.5 py-2.5 text-lg text-white shadow-sm"
              onClick={() => {
                save();
              }}
            >
              SAVE
            </button>
            <button
              type="button"
              className="m-3 rounded-md bg-white/10 px-3.5 py-2.5 text-lg text-white shadow-sm hover:bg-white/20"
              onClick={() => {
                setChangesPending(false);
              }}
            >
              CANCEL SAVE
            </button>
          </>
        )}
        {!changesPending && view !== "test" && (
          <div className="mt-auto ">
            <button
              className="w-full  mb-4  rounded-md bg-white/10 px-3.5 py-2.5 text-lg text-white shadow-sm hover:bg-white/20"
              onClick={() => {
                setView("test");
              }}
            >
              Test Mode
            </button>
          </div>
        )}
        {!changesPending && view === "test" && (
          <>
            <button
              type="button"
              className="m-3 rounded-md bg-white/10 px-3.5 py-2.5 text-lg text-white shadow-sm hover:bg-white/20"
              onClick={() => {
                fetch(
                  window?.ENV?.ROSS_DASHBOARD_SERVER?.replace(
                    "wss://",
                    "https://",
                  )?.replace("ws://", "http://"),
                  {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: "Bearer " + window?.ENV?.API_TOKEN,
                    },
                    body: JSON.stringify({
                      dashboard_id: "ROSS_1",
                      command: "4BOX",
                    }),
                  },
                );
              }}
            >
              4 WAY
            </button>
            <button
              type="button"
              className="m-3 rounded-md bg-white/10 px-3.5 py-2.5 text-lg text-white shadow-sm hover:bg-white/20"
              onClick={() => {
                fetch(
                  window?.ENV?.ROSS_DASHBOARD_SERVER?.replace(
                    "wss://",
                    "https://",
                  )?.replace("ws://", "http://"),
                  {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: "Bearer " + window?.ENV?.API_TOKEN,
                    },
                    body: JSON.stringify({
                      dashboard_id: "ROSS_1",
                      command: "EVS",
                    }),
                  },
                );
              }}
            >
              1 BOX
            </button>
            <button
              type="button"
              className="m-3 rounded-md bg-white/10 px-3.5 py-2.5 text-lg text-white shadow-sm hover:bg-white/20"
              onClick={() => {
                fetch(
                  window?.ENV?.ROSS_DASHBOARD_SERVER?.replace(
                    "wss://",
                    "https://",
                  )?.replace("ws://", "http://"),
                  {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: "Bearer " + window?.ENV?.API_TOKEN,
                    },
                    body: JSON.stringify({
                      dashboard_id: "ROSS_1",
                      command: "COMMENTARY",
                    }),
                  },
                );
              }}
            >
              COMMENTATOR
            </button>
            <button
              type="button"
              className="m-3 rounded-md bg-white/10 px-3.5 py-2.5 text-lg text-white shadow-sm hover:bg-white/20"
              onClick={() => {
                fetch(
                  window?.ENV?.ROSS_DASHBOARD_SERVER?.replace(
                    "wss://",
                    "https://",
                  )?.replace("ws://", "http://"),
                  {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: "Bearer " + window?.ENV?.API_TOKEN,
                    },
                    body: JSON.stringify({
                      dashboard_id: "ROSS_1",
                      command: "PROMOS",
                    }),
                  },
                );
              }}
            >
              PROMO
            </button>
            <button
              type="button"
              className="m-3 rounded-md bg-white/10 px-3.5 py-2.5 text-lg text-white shadow-sm hover:bg-white/20"
              onClick={() => {
                fetch(
                  window?.ENV?.ROSS_DASHBOARD_SERVER?.replace(
                    "wss://",
                    "https://",
                  )?.replace("ws://", "http://"),
                  {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: "Bearer " + window?.ENV?.API_TOKEN,
                    },
                    body: JSON.stringify({
                      dashboard_id: "ROSS_1",
                      command: "SLATE_CONCLUDED",
                    }),
                  },
                );
              }}
            >
              CONCLUDED
            </button>

            <button
              type="button"
              className="m-3 rounded-md bg-white/10 px-3.5 py-2.5 text-lg text-white shadow-sm hover:bg-white/20"
              onClick={() => {
                fetch(
                  window?.ENV?.ROSS_DASHBOARD_SERVER?.replace(
                    "wss://",
                    "https://",
                  )?.replace("ws://", "http://"),
                  {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: "Bearer " + window?.ENV?.API_TOKEN,
                    },
                    body: JSON.stringify({
                      dashboard_id: "ROSS_1",
                      command: "SLATE_SHORTLY",
                    }),
                  },
                );
              }}
            >
              SHORTLY
            </button>

            <button
              type="button"
              className="m-3 rounded-md bg-white/10 px-3.5 py-2.5 text-lg text-white shadow-sm hover:bg-white/20"
              onClick={() => {
                fetch(
                  window?.ENV?.ROSS_DASHBOARD_SERVER?.replace(
                    "wss://",
                    "https://",
                  )?.replace("ws://", "http://"),
                  {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: "Bearer " + window?.ENV?.API_TOKEN,
                    },
                    body: JSON.stringify({
                      dashboard_id: "ROSS_1",
                      command: "SLATE_SS+",
                    }),
                  },
                );
              }}
            >
              SS SLATE
            </button>

            <button
              type="button"
              className="m-3 rounded-md bg-white/10 px-3.5 py-2.5 text-lg text-white shadow-sm hover:bg-white/20"
              onClick={() => {
                fetch(
                  window?.ENV?.ROSS_DASHBOARD_SERVER?.replace(
                    "wss://",
                    "https://",
                  )?.replace("ws://", "http://"),
                  {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: "Bearer " + window?.ENV?.API_TOKEN,
                    },
                    body: JSON.stringify({
                      dashboard_id: "ROSS_1",
                      command: "SLATE_TEMP_FAULT",
                    }),
                  },
                );
              }}
            >
              TEMP FAULT
            </button>

            <button
              className="m-3 mt-auto rounded-md bg-white/10 px-3.5 py-2.5 text-lg text-white shadow-sm hover:bg-white/20"
              onClick={() => {
                setView("live");
              }}
            >
              Live Mode
            </button>
          </>
        )}
      </div>
    </div>
  );
}

function BasicGame({
  index,
  fixtures,
  games,
  channels,
  updateChannel,
  updateGame,
  view,
  updateScore,
  updateGameAndSave,
}) {
  return (
    <div className="flex m-1 p-4 shadow-sm bg-[#181d25] flex-col col-span-1">
      <Listbox
        value={games?.find((g) => g?.slot === index)}
        onChange={(value) => updateGame({ index, game: value })}
      >
        <div className="relative  mb-4">
          <ListboxButton className="grid w-full cursor-default grid-cols-1 rounded-md bg-[#0e1219] py-1.5 pl-3 pr-2 text-left outline outline-1 -outline-offset-1 outline-[#363c48] focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6">
            <span className="col-start-1 row-start-1 truncate pr-6">
              {games?.find((g) => g?.slot === index)?.description}
            </span>
            <ChevronUpDownIcon
              aria-hidden="true"
              className="col-start-1 row-start-1 size-5 self-center justify-self-end text-gray-500 sm:size-4"
            />
          </ListboxButton>

          <ListboxOptions
            transition
            className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-[#0e1219] py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in sm:text-sm"
          >
            {fixtures?.map((game) => (
              <ListboxOption
                key={game._id}
                value={game}
                className="group relative cursor-default select-none py-2 pl-3 pr-9 data-[focus]:bg-indigo-600 data-[focus]:text-white data-[focus]:outline-none"
              >
                <span className="block truncate font-normal group-data-[selected]:font-semibold">
                  {game.description}
                </span>

                <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600 group-[&:not([data-selected])]:hidden group-data-[focus]:text-white">
                  <CheckIcon aria-hidden="true" className="size-5" />
                </span>
              </ListboxOption>
            ))}
          </ListboxOptions>
        </div>
      </Listbox>
      {games?.find((g) => g?.slot === index) && (
        <Listbox
          value={games?.find((g) => g?.slot === index)?.channel}
          onChange={(value) => updateChannel({ index, channel: value })}
        >
          <div className="relative mb-4">
            <ListboxButton className="grid w-full cursor-default grid-cols-1 rounded-md bg-[#0e1219] py-1.5 pl-3 pr-2 text-left outline outline-1 -outline-offset-1 outline-[#363c48] focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6">
              <span className="col-start-1 row-start-1 truncate pr-6">
                {games?.find((g) => g?.slot === index)?.channel?.name}
              </span>
              <ChevronUpDownIcon
                aria-hidden="true"
                className="col-start-1 row-start-1 size-5 self-center justify-self-end text-gray-500 sm:size-4"
              />
            </ListboxButton>

            <ListboxOptions
              transition
              className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-[#0e1219] py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in sm:text-sm"
            >
              {channels?.map((channel) => (
                <ListboxOption
                  key={channel._id}
                  value={channel}
                  className="group relative cursor-default select-none py-2 pl-3 pr-9 data-[focus]:bg-indigo-600 data-[focus]:text-white data-[focus]:outline-none"
                >
                  <span className="block truncate font-normal group-data-[selected]:font-semibold">
                    {channel.name}
                  </span>

                  <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600 group-[&:not([data-selected])]:hidden group-data-[focus]:text-white">
                    <CheckIcon aria-hidden="true" className="size-5" />
                  </span>
                </ListboxOption>
              ))}
            </ListboxOptions>
          </div>
        </Listbox>
      )}
      {games?.find((g) => g?.slot === index) && (
        <>
          <div className="flex items-center mt-4 gap-x-3">
            <button
              className={`rounded-md px-3.5 py-2.5 text-sm text-white shadow-sm ${
                games?.find((g) => g?.slot === index)?.mode !== "manual"
                  ? "bg-indigo-600"
                  : "bg-white/10"
              }`}
              onClick={() => {
                updateGameAndSave({
                  index,
                  game: {
                    ...games?.find((g) => g?.slot === index),
                    mode: "auto",
                  },
                });
              }}
            >
              Auto Score
            </button>
            <button
              className={`rounded-md px-3.5 py-2.5 text-sm text-white shadow-sm ${
                games?.find((g) => g?.slot === index)?.mode === "manual"
                  ? "bg-indigo-600"
                  : "bg-white/10"
              }`}
              onClick={() => {
                updateGameAndSave({
                  index,
                  game: {
                    ...games?.find((g) => g?.slot === index),
                    mode: "manual",
                  },
                });
              }}
            >
              Manual Score
            </button>
          </div>
          {games?.find((g) => g?.slot === index)?.mode !== "manual" && (
            <div className="flex items-center mt-4">
              <div className="flex  gap-x-3 ">
                <div
                  className={`rounded-md px-3.5 py-2.5 text-sm  shadow-sm ${
                    games?.find((g) => g?.slot === index)?.status === "vs"
                      ? "text-indigo-600"
                      : "text-white/10"
                  }`}
                >
                  VS
                </div>
                <div
                  className={`rounded-md px-3.5 py-2.5 text-sm  shadow-sm ${
                    games?.find((g) => g?.slot === index)?.status === "in_game"
                      ? "text-indigo-600"
                      : "text-white/10"
                  }`}
                >
                  IN GAME
                </div>
                <div
                  className={`rounded-md px-3.5 py-2.5 text-sm  shadow-sm ${
                    games?.find((g) => g?.slot === index)?.status ===
                    "half_time"
                      ? "text-indigo-600"
                      : "text-white/10"
                  }`}
                >
                  HT
                </div>
                <div
                  className={`rounded-md px-3.5 py-2.5 text-sm  shadow-sm  ${
                    games?.find((g) => g?.slot === index)?.status ===
                    "full_time"
                      ? "text-indigo-600"
                      : "text-white/10"
                  }`}
                >
                  FT
                </div>
              </div>

              <div className="flex ml-auto">
                Position:
                <span className="ml-2">
                  {games?.find((g) => g?.slot === index)?.position}
                </span>
              </div>
            </div>
          )}
          {games?.find((g) => g?.slot === index)?.mode === "manual" && (
            <div className="flex items-center mt-4">
              <div className="flex  gap-x-3 ">
                <div
                  onClick={() => {
                    updateScore({
                      index,
                      game: {
                        ...games?.find((g) => g?.slot === index),
                        status: "vs",
                      },
                    });
                  }}
                  className={`cursor-pointer rounded-md px-3.5 py-2.5 text-sm text-white shadow-sm ${
                    games?.find((g) => g?.slot === index)?.status === "vs"
                      ? "bg-indigo-600"
                      : "bg-white/10"
                  }`}
                >
                  VS
                </div>
                <div
                  onClick={() => {
                    updateScore({
                      index,
                      game: {
                        ...games?.find((g) => g?.slot === index),
                        status: "in_game",
                      },
                    });
                  }}
                  className={`cursor-pointer rounded-md px-3.5 py-2.5 text-sm text-white shadow-sm ${
                    games?.find((g) => g?.slot === index)?.status === "in_game"
                      ? "bg-indigo-600"
                      : "bg-white/10"
                  }`}
                >
                  IN GAME
                </div>
                <div
                  onClick={() => {
                    updateScore({
                      index,
                      game: {
                        ...games?.find((g) => g?.slot === index),
                        status: "half_time",
                      },
                    });
                  }}
                  className={`cursor-pointer rounded-md px-3.5 py-2.5 text-sm text-white shadow-sm ${
                    games?.find((g) => g?.slot === index)?.status ===
                    "half_time"
                      ? "bg-indigo-600"
                      : "bg-white/10 "
                  }`}
                >
                  HT
                </div>
                <div
                  onClick={() => {
                    updateScore({
                      index,
                      game: {
                        ...games?.find((g) => g?.slot === index),
                        status: "full_time",
                      },
                    });
                  }}
                  className={`cursor-pointer rounded-md px-3.5 py-2.5 text-sm text-white shadow-sm  ${
                    games?.find((g) => g?.slot === index)?.status ===
                    "full_time"
                      ? "bg-indigo-600 "
                      : "bg-white/10 "
                  }`}
                >
                  FT
                </div>
              </div>
              <div className="flex ml-auto">
                Position:
                <span className="ml-2">
                  {games?.find((g) => g?.slot === index)?.position}
                </span>
              </div>
            </div>
          )}
        </>
      )}
      {games?.find((g) => g?.slot === index) && (
        <div className="flex justify-evenly items-center h-full">
          {games?.find((g) => g?.slot === index)?.mode !== "manual" && (
            <div className="flex flex-col gap-y-2">
              <div
                className={`rounded-md px-3.5 py-2.5 text-sm  shadow-sm ${
                  games?.find((g) => g?.slot === index)?.home_team_kit ===
                  "home"
                    ? "text-indigo-600"
                    : "text-white/10"
                }`}
              >
                HOME KIT
              </div>
              <div
                className={`rounded-md px-3.5 py-2.5 text-sm  shadow-sm ${
                  games?.find((g) => g?.slot === index)?.home_team_kit ===
                  "away"
                    ? "text-indigo-600"
                    : "text-white/10"
                }`}
              >
                AWAY KIT
              </div>
              <div
                className={`rounded-md px-3.5 py-2.5 text-sm  shadow-sm ${
                  games?.find((g) => g?.slot === index)?.home_team_kit ===
                  "third"
                    ? "text-indigo-600"
                    : "text-white/10"
                }`}
              >
                THIRD KIT
              </div>
            </div>
          )}
          {games?.find((g) => g?.slot === index)?.mode === "manual" && (
            <div className="flex flex-col gap-y-2">
              <div
                className={`cursor-pointer rounded-md px-3.5 py-2.5 text-sm text-white shadow-sm ${
                  games?.find((g) => g?.slot === index)?.home_team_kit ===
                  "home"
                    ? "bg-indigo-600"
                    : "bg-white/10"
                }`}
                onClick={() => {
                  updateScore({
                    index,
                    game: {
                      ...games?.find((g) => g?.slot === index),
                      home_team_kit: "home",
                    },
                  });
                }}
              >
                HOME KIT
              </div>
              <div
                className={`cursor-pointer rounded-md px-3.5 py-2.5 text-sm text-white shadow-sm ${
                  games?.find((g) => g?.slot === index)?.home_team_kit ===
                  "away"
                    ? "bg-indigo-600"
                    : "bg-white/10"
                }`}
                onClick={() => {
                  updateScore({
                    index,
                    game: {
                      ...games?.find((g) => g?.slot === index),
                      home_team_kit: "away",
                    },
                  });
                }}
              >
                AWAY KIT
              </div>
              <div
                className={`cursor-pointer rounded-md px-3.5 py-2.5 text-sm text-white shadow-sm ${
                  games?.find((g) => g?.slot === index)?.home_team_kit ===
                  "third"
                    ? "bg-indigo-600"
                    : "bg-white/10"
                }`}
                onClick={() => {
                  updateScore({
                    index,
                    game: {
                      ...games?.find((g) => g?.slot === index),
                      home_team_kit: "third",
                    },
                  });
                }}
              >
                THIRD KIT
              </div>
            </div>
          )}
          <div className="flex items-center text-8xl">
            {games?.find((g) => g?.slot === index)?.mode === "manual" && (
              <button
                type="button"
                className="m-4 rounded-md bg-white/10 px-3.5 py-2.5 text-lg text-white shadow-sm hover:bg-white/20"
                onClick={() => {
                  updateScore({
                    index,
                    game: {
                      ...games?.find((g) => g?.slot === index),
                      home_score: Math.max(
                        0,
                        games?.find((g) => g?.slot === index)?.home_score - 1,
                      ),
                    },
                  });
                }}
              >
                -
              </button>
            )}
            {games?.find((g) => g?.slot === index)?.home_score}
            {games?.find((g) => g?.slot === index)?.mode === "manual" && (
              <button
                type="button"
                className="m-4 rounded-md bg-white/10 px-3.5 py-2.5 text-lg text-white shadow-sm hover:bg-white/20"
                onClick={() => {
                  updateScore({
                    index,
                    game: {
                      ...games?.find((g) => g?.slot === index),
                      home_score:
                        games?.find((g) => g?.slot === index)?.home_score + 1,
                    },
                  });
                }}
              >
                +
              </button>
            )}
          </div>
          -
          <div className="flex items-center text-8xl">
            {games?.find((g) => g?.slot === index)?.mode === "manual" && (
              <button
                type="button"
                className="m-4 rounded-md bg-white/10 px-3.5 py-2.5 text-lg text-white shadow-sm hover:bg-white/20"
                onClick={() =>
                  updateScore({
                    index,
                    game: {
                      ...games?.find((g) => g?.slot === index),
                      away_score: Math.max(
                        0,
                        games?.find((g) => g?.slot === index)?.away_score - 1,
                      ),
                    },
                  })
                }
              >
                -
              </button>
            )}
            {games?.find((g) => g?.slot === index)?.away_score}
            {games?.find((g) => g?.slot === index)?.mode === "manual" && (
              <button
                type="button"
                className="m-4 rounded-md bg-white/10 px-3.5 py-2.5 text-lg text-white shadow-sm hover:bg-white/20"
                onClick={() => {
                  updateScore({
                    index,
                    game: {
                      ...games?.find((g) => g?.slot === index),
                      away_score:
                        games?.find((g) => g?.slot === index)?.away_score + 1,
                    },
                  });
                }}
              >
                +
              </button>
            )}
          </div>
          {games?.find((g) => g?.slot === index)?.mode !== "manual" && (
            <div className="flex flex-col gap-y-2">
              <div
                className={`rounded-md px-3.5 py-2.5 text-sm  shadow-sm ${
                  games?.find((g) => g?.slot === index)?.away_team_kit ===
                  "home"
                    ? "text-indigo-600"
                    : "text-white/10"
                }`}
              >
                HOME KIT
              </div>
              <div
                className={`rounded-md px-3.5 py-2.5 text-sm  shadow-sm ${
                  games?.find((g) => g?.slot === index)?.away_team_kit ===
                  "away"
                    ? "text-indigo-600"
                    : "text-white/10"
                }`}
              >
                AWAY KIT
              </div>
              <div
                className={`rounded-md px-3.5 py-2.5 text-sm  shadow-sm ${
                  games?.find((g) => g?.slot === index)?.away_team_kit ===
                  "third"
                    ? "text-indigo-600"
                    : "text-white/10"
                }`}
              >
                THIRD KIT
              </div>
            </div>
          )}
          {games?.find((g) => g?.slot === index)?.mode === "manual" && (
            <div className="flex flex-col gap-y-2">
              <div
                className={`cursor-pointer rounded-md px-3.5 py-2.5 text-sm text-white shadow-sm ${
                  games?.find((g) => g?.slot === index)?.away_team_kit ===
                  "home"
                    ? "bg-indigo-600"
                    : "bg-white/10"
                }`}
                onClick={() => {
                  updateScore({
                    index,
                    game: {
                      ...games?.find((g) => g?.slot === index),
                      away_team_kit: "home",
                    },
                  });
                }}
              >
                HOME KIT
              </div>
              <div
                className={`cursor-pointer rounded-md px-3.5 py-2.5 text-sm text-white shadow-sm ${
                  games?.find((g) => g?.slot === index)?.away_team_kit ===
                  "away"
                    ? "bg-indigo-600"
                    : "bg-white/10"
                }`}
                onClick={() => {
                  updateScore({
                    index,
                    game: {
                      ...games?.find((g) => g?.slot === index),
                      away_team_kit: "away",
                    },
                  });
                }}
              >
                AWAY KIT
              </div>
              <div
                className={`cursor-pointer rounded-md px-3.5 py-2.5 text-sm text-white shadow-sm ${
                  games?.find((g) => g?.slot === index)?.away_team_kit ===
                  "third"
                    ? "bg-indigo-600"
                    : "bg-white/10"
                }`}
                onClick={() => {
                  updateScore({
                    index,
                    game: {
                      ...games?.find((g) => g?.slot === index),
                      away_team_kit: "third",
                    },
                  });
                }}
              >
                THIRD KIT
              </div>
            </div>
          )}
        </div>
      )}
      {view === "test" && (
        <div className="flex gap-x-2 mt-4">
          <button
            type="button"
            className="rounded-md bg-white/10 px-3.5 py-2.5 text-lg text-white shadow-sm hover:bg-white/20"
            onClick={() => {
              fetch(
                window?.ENV?.ROSS_DASHBOARD_SERVER?.replace(
                  "wss://",
                  "https://",
                )?.replace("ws://", "http://"),
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + window?.ENV?.API_TOKEN,
                  },
                  body: JSON.stringify({
                    dashboard_id: "ROSS_1",
                    command: "GAME_" + index + "_HERO",
                  }),
                },
              );
            }}
          >
            SET AS HERO
          </button>
          <button
            type="button"
            className="rounded-md bg-white/10 px-3.5 py-2.5 text-lg text-white shadow-sm hover:bg-white/20"
            onClick={() => {
              fetch(
                window?.ENV?.ROSS_DASHBOARD_SERVER?.replace(
                  "wss://",
                  "https://",
                )?.replace("ws://", "http://"),
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + window?.ENV?.API_TOKEN,
                  },
                  body: JSON.stringify({
                    dashboard_id: "ROSS_1",
                    command: "GAME_" + index + "_REPLAY",
                  }),
                },
              );
            }}
          >
            REPLAY
          </button>
          <button
            type="button"
            className="rounded-md bg-white/10 px-3.5 py-2.5 text-lg text-white shadow-sm hover:bg-white/20"
            onClick={() => {
              fetch(
                window?.ENV?.ROSS_DASHBOARD_SERVER?.replace(
                  "wss://",
                  "https://",
                )?.replace("ws://", "http://"),
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + window?.ENV?.API_TOKEN,
                  },
                  body: JSON.stringify({
                    dashboard_id: "ROSS_1",
                    command: "GAME_" + index + "_SLATE_ON",
                  }),
                },
              );
            }}
          >
            SLATE ON
          </button>
          <button
            type="button"
            className="rounded-md bg-white/10 px-3.5 py-2.5 text-lg text-white shadow-sm hover:bg-white/20"
            onClick={() => {
              fetch(
                window?.ENV?.ROSS_DASHBOARD_SERVER?.replace(
                  "wss://",
                  "https://",
                )?.replace("ws://", "http://"),
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + window?.ENV?.API_TOKEN,
                  },
                  body: JSON.stringify({
                    dashboard_id: "ROSS_1",
                    command: "GAME_" + index + "_SLATE_OFF",
                  }),
                },
              );
            }}
          >
            SLATE OFF
          </button>
          <button
            type="button"
            className="rounded-md bg-white/10 px-3.5 py-2.5 text-lg text-white shadow-sm hover:bg-white/20"
            onClick={() => {
              fetch(
                window?.ENV?.ROSS_DASHBOARD_SERVER?.replace(
                  "wss://",
                  "https://",
                )?.replace("ws://", "http://"),
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + window?.ENV?.API_TOKEN,
                  },
                  body: JSON.stringify({
                    dashboard_id: "ROSS_1",
                    command: "GAME_" + index + "_FULLFRAME",
                  }),
                },
              );
            }}
          >
            FULLFRAME
          </button>
        </div>
      )}
    </div>
  );
}
export default App;
